import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import 'semantic-ui-css/semantic.min.css';
import Admin from './admin';
import Domain from './functions/domainName';
import Customer from './customer';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#abb119',
      contrastText: '#ffffff',
    }
  }
});

class App extends Component {
  componentDidMount() {
      localStorage.setItem('salesMenu', true);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
      if (window.location.pathname === '/') {
        console.log("Redirecting to /vdms");
        window.location.pathname = '/vdms';
      }
      
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Admin />
      </MuiThemeProvider>
    );
  }
}

export default App;
